export default class technologyModel {
    constructor({id,name, description,language, icon, is_active, created_by, created_by_name}) {
        this.id = id;
        this.name = name;
        this.deskripsi = description;
        this.language = language;
        this.icon = icon;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
    }
}